export interface Dataset {
    id: string,
    text: string,
}

export interface Play {
    id: number,
    name: string,
    club: string,
    classroom: string,
    gid: string,
    turn: number,
    room_num: number,
    floor_num: number,
    water: number,
    magenta: number,
    cyan: number,
    gold: number,
    yellow: number,
    lover_name: string,
    lover_nick: string,
    lover_flower: string,
    lover_classroom: string,
    lover_club: string,
    lover_point: number,
    lover_end: string,
}

export interface Event {
    room_num: number,
    floor_num: number,
    type_id: number,
    bottles: Bottle[],
}

export interface Bottle {
    id: number,
    color: string,
    used: boolean,
}

export interface EventParam {
    event: Event,
    bottles: Bottle[],
    selected: number,
    called: number,
    message: string,
    talks: string[],
    talk_id: number,
}

export class Inc {
    static readonly defaultPlay = ()=>{
        const play:Play = {
            id: 0,
            name: "",
            club: "",
            classroom: "",
            gid: "",
            turn: 0,
            room_num: 1,
            floor_num: 1,
            water: 0,
            magenta: 0,
            cyan: 0,
            yellow: 0,
            gold: 0,
            lover_name: "",
            lover_nick: "",
            lover_flower: "",
            lover_classroom: "",
            lover_club: "",
            lover_point: 0,
            lover_end: "0",
        }
        return play;
    }
    static readonly defaultEvent = ()=>{
        const event:Event = {
            room_num: 1,
            floor_num: 1,
            type_id: 0,
            bottles: [],
        }
        return event;
    }
    static readonly clubs:string[] = [
        "吹奏楽部","弓道部","陸上部","美術部","水泳部","野球部","庭球部","演劇部","放送部","文芸部","帰宅部","卓球部","軽音部","排球部","籠球部","合唱部","光画部","茶道部","電子部","馬術部","奇術部","華道部","武道部","剣道部","映画部","漫画部",
    ]
    static readonly classrooms:string[] = [
        "1-A","1-B","1-C","1-D","1-E","2-A","2-B","2-C","2-D","2-E","3-A","3-B","3-C","3-D","3-E",
    ]
    static readonly coinFroms:string[] = [
        "ベッドの下から","枕の下から","足元の隙間に","壁との隙間に","シーツの下から","枕の中から",
    ]
}